import { useTheme } from "@mui/material";

import * as echarts from "echarts/core";
import { useMemo } from "react";
import ReactEChart from "../../../base/ReactEChart";

const EarningsChart = ({ chartRef, ...rest }) => {
  const theme = useTheme();

  const option = useMemo(
    () => ({
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 100,
          radius: "190%",
          center: ["50%", "100%"],
          splitNumber: 10,
          itemStyle: {
            color: theme.palette.primary.main,
            borderWidth: 0,
          },
          progress: {
            show: true,
            roundCap: false,
            width: 40,
          },
          pointer: {
            icon: "roundRect",
            length: "50%",
            width: 5,
            offsetCenter: [0, -90],
            itemStyle: {
              borderWidth: 20,
            },
          },
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 40,
              color: [[1, theme.palette.grey[800]]],
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          title: {
            show: false,
          },
          detail: {
            show: false,
          },
          data: [
            {
              value: 80,
            },
          ],
        },
      ],
    }),
    [theme]
  );

  return (
    <ReactEChart
      ref={chartRef}
      option={option}
      echarts={echarts}
      {...rest}
      mx="auto"
    />
  );
};

export default EarningsChart;
